import Title from 'components/common/Title';
import { useIntl } from 'react-intl';
import Content from 'components/common/Content-v2';
import ManualPaymemtForm from 'components/forms/manualPayment/add';

const ManualPayment = () => {
	const { formatMessage } = useIntl();
	return (
		<>
			<Title>
				<h1>{formatMessage({ id: 'payments.manual' })}</h1>
			</Title>
			<Content>
				<ManualPaymemtForm />
			</Content>
		</>
	);
};
export default ManualPayment;
